import React from 'react';
import { Paper, Typography } from '@mui/material';

const FormSection = ({ title, children }) => (
  <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
    {title && (
      <Typography variant="h6"
        sx={{ fontWeight: "bold", mb: 2, color: "text.primary" }}
      >
        {title}
      </Typography>
    )}
    {children}
  </Paper>
);

export default FormSection;